import { render, staticRenderFns } from "./ViolationPage.vue?vue&type=template&id=0d60ba8e&scoped=true&"
import script from "./ViolationPage.vue?vue&type=script&lang=js&"
export * from "./ViolationPage.vue?vue&type=script&lang=js&"
import style0 from "./ViolationPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ViolationPage.vue?vue&type=style&index=1&id=0d60ba8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d60ba8e",
  null
  
)

export default component.exports